import React from 'react'
import { useTheme } from 'styled-components'
import {
  faPlus,
  faIndustry,
  faBinoculars,
  faChartSimple,
  faMemory,
  faSquarePollHorizontal,
  faSquarePlus,
  faSun,
  faGasPump,
  faWind,
  faQuestion,
  faQuestionCircle,
  faTrashAlt,
  faFileArrowUp,
  faUser,
  faArrowUp,
  faAngleUp,
  faBars,
  faAngleDown,
  faGear,
  faPenToSquare,
  faRightLeft,
  faFileArrowDown,
} from '@fortawesome/free-solid-svg-icons'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'
import { Color } from '../../theme'

library.add(
  faArrowUp,
  faAngleUp,
  faAngleDown,
  faBars,
  faUser,
  faTrashAlt,
  faQuestion,
  faQuestionCircle,
  faChartSimple,
  faPlus,
  faIndustry,
  faBinoculars,
  faMemory,
  faSquarePollHorizontal,
  faSquarePlus,
  faSun,
  faGasPump,
  faWind,
  faFileArrowUp,
  faFileArrowDown,
  faGear,
  faPenToSquare,
  faRightLeft,
)

interface Props extends FontAwesomeIconProps {
  color?: Color
  margin?: boolean
  className?: string
}

const Icon: React.FC<Props> = ({ color = 'inherit', margin = true, className = '', ...props }) => {
  const theme = useTheme()
  const themedColor = theme.getThemedColor(color)

  return (
    <FontAwesomeIcon
      color={themedColor}
      className={`${className} ${margin ? 'mr-8' : ''}`}
      {...props}
    />
  )
}

export default Icon
